import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddressModule } from '@x/ecommerce-shop/app/core/address/address.module';
import { AddressBookComponent } from '@x/ecommerce-shop/app/core/address/components/address-book/address-book.component';
import { IDefaultAddressDialogData } from '@x/ecommerce-shop/app/core/auth/services/user-address-dialog.service';
import { BannerButtonModule } from '@x/ecommerce-shop/app/core/shop-ui/components/banner-button/banner-button.module';
import { IconUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/icon-ui/icon-ui.module';
import { ShopDialogUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-dialog-ui/shop-dialog-ui.module';
import { SubscriberPillsComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/subscriber-pills/subscriber-pills.component';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { IShopAddressInput, IShopUserAddress } from '@x/ecommerce/shop-client';

@Component({
  selector: 'x-choose-default-address-dialog',
  imports: [
    BannerButtonModule,
    ShopDialogUiModule,
    IconUiModule,
    UtilsModule,
    AddressModule,
    SubscriberPillsComponent,
    AddressBookComponent,
  ],
  templateUrl: './choose-default-address-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChooseDefaultAddressDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ChooseDefaultAddressDialogComponent>);
  data = inject<IDefaultAddressDialogData>(MAT_DIALOG_DATA);

  get heading() {
    let heading = 'Set new default';

    if (this.data.subscribers?.length) {
      heading = 'Address is Linked to Subscriptions';
    }
    return heading;
  }

  get subheading() {
    let subheading =
      'Please select one of your existing addresses or create a new address to set as default.';

    if (this.data.subscribers?.length) {
      subheading =
        'You have active subscriptions that require a default shipping address. Please select one of your existing addresses or create a new address to keep your subscriptions active.';
    }
    return subheading;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  constructor() {}

  addressCreated(addressInput: IShopAddressInput) {
    this.dialogRef.close({ newAddressInput: addressInput });
  }

  setAsDefaultAddress(address: IShopUserAddress) {
    this.dialogRef.close({ existingAddressId: address.id });
  }
}
